import axios from 'axios';
import apiConfig from '../config/apiConfig';

const BASE_URL = apiConfig.BASE_URL;

function getStoredToken() {
  try {
    const persistRoot = localStorage.getItem('persist:root');
    if (persistRoot) {
      const parsed = JSON.parse(persistRoot);
      if (parsed.auth) {
        const authState = JSON.parse(parsed.auth);
        return authState.token;
      }
    }
  } catch (e) {
    console.warn('Could not read token from redux-persist:', e);
  }
  return localStorage.getItem('storehub_token') || sessionStorage.getItem('storehub_token');
}

function getAuthHeaders() {
  const token = getStoredToken();
  if (!token || token === 'null' || token === 'undefined') {
    throw new Error('Authentication required. Please log in again.');
  }
  return { headers: { Authorization: `Bearer ${token}` } };
}

export const fetchProducts = async (params = {}) => {
  const auth = getAuthHeaders();
  const response = await axios.get(`${BASE_URL}/api/products`, { ...auth, params });
  return response.data;
};

export const fetchProductStats = async () => {
  const auth = getAuthHeaders();
  const response = await axios.get(`${BASE_URL}/api/products/stats`, auth);
  return response.data;
};

export const getProductById = async (id) => {
  const auth = getAuthHeaders();
  const response = await axios.get(`${BASE_URL}/api/products/${id}`, auth);
  return response.data;
};

export const createProduct = async (payload) => {
  const auth = getAuthHeaders();
  const response = await axios.post(`${BASE_URL}/api/products`, payload, auth);
  return response.data;
};

export const updateProduct = async (id, payload) => {
  const auth = getAuthHeaders();
  const response = await axios.put(`${BASE_URL}/api/products/${id}`, payload, auth);
  return response.data;
};

export const deleteProduct = async (id) => {
  const auth = getAuthHeaders();
  await axios.delete(`${BASE_URL}/api/products/${id}`, auth);
  return id;
};
